import styled from 'styled-components'

export const Contact = styled.div`
  background: #ffffff;
  padding: 80px 0 80px;
  overflow: hidden;

  .title {
    font-size: 36px;
    font-weight: 900;
    color: #000;
    margin-bottom: 5px;
  }

  .subtitle {
    font-size: 28px;
    line-height: 32px;
    margin-bottom: 50px;
  }

  .grid {
    display: flex;

    > div {
      flex: 1;
    }
  }

  .calendar {
    width: 660px;
    height: auto;
    position: relative;
    margin-left: -130px;
  }

  @media screen and (max-width: 1000px) {
    .grid {
      flex-direction: column;
    }

    .calendar {
      width: 360px;
      margin-left: 0;
    }
  }
`